export const apartmentServiceMapper = (data) => ({
    id: data.id,
    nameIt: data.nameIt,
    group: data.group,
})